import {
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  DoCheck,
  forwardRef,
  Component,
  ViewChild,
  Output,
  EventEmitter,
  IterableDiffers,
  IterableDiffer,
  IterableChangeRecord,
  IterableChanges,
  ViewEncapsulation,
  Renderer2,
  OnDestroy
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  FormControl
} from '@angular/forms';

import * as _ from 'lodash';
import { SelectizeConfig } from './selectize.config';
import {ISelectizeItem} from './selectize-item.interface';

declare var $: any;

export const SELECTIZE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectizeComponent),
  multi: true
};

@Component({
  selector: 'hxa-selectize',
  template: `<select #selectizeInput></select>`,
  providers: [SELECTIZE_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None,
  styles: [`.selectize-control{position:relative}.selectize-dropdown,.selectize-input,.selectize-input input{color:#2a2c2d;font-family:inherit;font-size:.92rem;line-height:1.5;-webkit-font-smoothing:inherit}.selectize-control.single .selectize-input.input-active,.selectize-input{background:0 0;cursor:text;display:inline-block}.selectize-input{border:1px solid rgba(0,0,0,.2);padding:8px;display:inline-block;width:100%;overflow:hidden;position:relative;z-index:1;box-sizing:border-box;box-shadow:none;border-radius:0;border-width:0 0 1px}.selectize-control.multi .selectize-input.has-items{padding:6px 8px 3px}.selectize-input.full{background-color:transparent}.selectize-input.disabled,.selectize-input.disabled *{cursor:default!important}.selectize-input.focus{box-shadow:none}.selectize-input.dropdown-active{border-radius:0}.selectize-input>*{vertical-align:baseline;display:inline-block;zoom:1}.selectize-control.multi .selectize-input>div{cursor:pointer;margin:4px;padding:2px 6px;background:rgba(0,0,0,.05);color:#2a2c2d;border:0 solid transparent;border-radius:290486px;font-size:.75rem;justify-content:center;line-height:1.5;white-space:nowrap}.selectize-control.multi .selectize-input>div.active{background:#e8e8e8;color:#2a2c2d;border:0 solid #cacaca}.selectize-control.multi .selectize-input.disabled>div,.selectize-control.multi .selectize-input.disabled>div.active{color:#787878;background:rgba(77,77,77,.05);border:0 solid rgba(77,77,77,0)}.selectize-input>input{display:inline-block!important;padding:0!important;min-height:0!important;max-height:none!important;max-width:100%!important;margin:0 2px 0 0!important;text-indent:0!important;border:0!important;background:0 0!important;line-height:inherit!important;-webkit-user-select:auto!important}.selectize-input>input::-ms-clear{display:none}.selectize-input>input:focus{outline:0!important}.selectize-input::after{content:' ';display:block;clear:left}.selectize-input.dropdown-active::before{content:' ';display:block;position:absolute;background:#f0f0f0;height:1px;bottom:0;left:0;right:0}.hx-select-control:after{display:none}.selectize-dropdown{position:absolute;z-index:10;border:transparent;background:#fff;margin:-1px 0 0;border-top:0;box-sizing:border-box;box-shadow:0 6px 12px rgba(0,0,0,.145);border-radius:0}.selectize-dropdown [data-selectable]{cursor:pointer;overflow:hidden}.selectize-dropdown [data-selectable] .highlight{background:rgba(35,49,43,.23);border-radius:1px;font-weight:700}.selectize-dropdown .optgroup-header,.selectize-dropdown [data-selectable]{padding:5px 8px}.selectize-dropdown .optgroup:first-child .optgroup-header{border-top:0}.selectize-dropdown .optgroup-header{color:#2a2c2d;background:#fff;cursor:default}.selectize-dropdown .active{background-color:#41b987;color:#fff}.selectize-dropdown .active.create{color:#fff}.selectize-dropdown .create{color:rgba(42,44,45,.5)}.selectize-dropdown-content{overflow-y:auto;overflow-x:hidden;max-height:200px;-webkit-overflow-scrolling:touch}.selectize-control.single .selectize-input,.selectize-control.single .selectize-input input{cursor:pointer}.selectize-control.single .selectize-input.input-active,.selectize-control.single .selectize-input.input-active input{cursor:text}.selectize-control.single .selectize-input:after{content:' ';display:block;position:absolute;top:50%;right:15px;margin-top:-3px;width:0;height:0;border-style:solid;border-width:5px 5px 0;border-color:grey transparent transparent}.selectize-control.single .selectize-input.dropdown-active:after{margin-top:-4px;border-width:0 5px 5px;border-color:transparent transparent grey}.selectize-control.rtl.single .selectize-input:after{left:15px;right:auto}.selectize-control.rtl .selectize-input>input{margin:0 4px 0 -2px!important}.selectize-control .selectize-input.disabled{opacity:.5;background-color:#fafafa}.selectize-control.plugin-remove_button [data-value]{position:relative;padding-right:.7rem!important}.selectize-control.plugin-remove_button [data-value].is-medium{padding-right:1rem!important}.selectize-control.plugin-remove_button [data-value] .hx-delete{margin-left:-.2rem;height:16px;width:16px;max-height:16px;max-width:16px;min-height:16px;min-width:16px}.selectize-control.plugin-remove_button [data-value].is-medium .hx-delete{margin-left:-.5rem}.selectize-control.plugin-remove_button [data-value].is-large .hx-delete{margin-left:-.2rem;height:20px;width:20px;max-height:20px;max-width:20px;min-height:20px;min-width:20px}.selectize-control.plugin-remove_button .disabled [data-value] .hx-remove:hover{background:0 0}.selectize-control.plugin-remove_button .disabled [data-value] .hx-remove{border-left-color:rgba(77,77,77,0)}.selectize-control.plugin-remove_button .remove-single{position:absolute;right:28px;top:6px;font-size:23px}`]
})
export class SelectizeComponent
  implements OnInit, OnChanges, DoCheck, ControlValueAccessor, OnDestroy {
  private _options: any[];
  private _options_differ: IterableDiffer<any>;
  private _optgroups: any[];
  private _optgroups_differ: IterableDiffer<any>;

  @Input() config: SelectizeConfig;
  @Input() id: string;
  @Input() placeholder: string;
  @Input() hasOptionsPlaceholder: string;
  @Input() noOptionsPlaceholder: string;
  @Input() enabled = true;
  @Input() value: ISelectizeItem[];
  @Input() formControl: FormControl;
  @Input() errorClass: string;

  @Output() onBlur: EventEmitter<void> = new EventEmitter<void>(false);

  @ViewChild('selectizeInput') selectizeInput: any;

  private selectize: any;

  // Control value accessors.
  private onTouchedCallback: () => {};
  private onChangeCallback: (_: any) => {};

  constructor(private _differs: IterableDiffers, private renderer: Renderer2) {}

  ngOnInit(): void {
    if (this.id && this.id.length > 0) {
      this.renderer.setAttribute(
        this.selectizeInput.nativeElement,
        'id',
        this.id
      );
    }
    this.reset();
  }

  reset() {
    this.selectize = $(this.selectizeInput.nativeElement).selectize(
      this.config
    )[0].selectize;
    this.selectize.on('change', this.onSelectizeValueChange.bind(this));
    this.selectize.on('blur', this.onBlurEvent.bind(this));
    this.selectize.on('type', this.onSelectizeType.bind(this));
    this.selectize.on('item_add', this.onSelectizeItemSelected.bind(this));
    this.updatePlaceholder();
    this.onEnabledStatusChange();
  }

  ngOnDestroy() {
    this.selectize.off('change');
    this.selectize.off('blur');
    this.selectize.off('type');
  }

  /**
   * Change detection for primitive types.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (this.selectize) {
      if (
        changes.hasOwnProperty('placeholder') ||
        changes.hasOwnProperty('hasOptionsPlaceholder') ||
        changes.hasOwnProperty('noOptionsPlaceholder')
      ) {
        this.updatePlaceholder();
      }
      if (changes.hasOwnProperty('enabled')) {
        this.onEnabledStatusChange();
      }
    }
  }

  /**
   * Implementing deep check for option comparison
   *
   * FIXME -> Implement deep check to only compare against label and value fields.
   */
  ngDoCheck(): void {
    if (this._options_differ) {
      const changes = this._options_differ.diff(this._options);
      if (changes) {
        this._applyOptionsChanges(changes);
      }
    }
    if (this._optgroups_differ) {
      const changes = this._optgroups_differ.diff(this._optgroups);
      if (changes) {
        this._applyOptionGroupChanges(changes);
      }
    }
  }

  private _applyOptionsChanges(changes: IterableChanges<any>): void {
    changes.forEachAddedItem((record: IterableChangeRecord<any>) => {
      this.onSelectizeOptionAdd(record.item);
    });
    changes.forEachRemovedItem((record: IterableChangeRecord<any>) => {
      this.onSelectizeOptionRemove(record.item);
    });
    this.updatePlaceholder();
    this.evalHasError();
  }

  private _applyOptionGroupChanges(changes: any): void {
    changes.forEachAddedItem((record: IterableChangeRecord<any>) => {
      this.onSelectizeOptGroupAdd(record.item);
    });
    changes.forEachRemovedItem((record: IterableChangeRecord<any>) => {
      this.onSelectizeOptGroupRemove(record.item);
    });
    this.updatePlaceholder();
    this.evalHasError();
  }

  private clearhighlight(): void {
    // remove highlight to help selectize bug
    // https://github.com/selectize/selectize.js/issues/1141
    this.selectize.$dropdown_content.removeHighlight();
  }

  onBlurEvent() {
    if (this.formControl) {
      this.formControl.markAsTouched();
    }
    this.onBlur.emit();
    this.evalHasError();
  }

  onSelectizeOptGroupAdd(optgroup: any): void {
    this.selectize.addOptionGroup(optgroup[this.getOptgroupField()], optgroup);
  }

  onSelectizeOptGroupRemove(optgroup: any): void {
    this.selectize.removeOptionGroup(optgroup[this.getOptgroupField()]);
  }

  /**
   * Refresh selected values when options change.
   */
  onSelectizeOptionAdd(option: any): void {
    this.selectize.addOption(_.cloneDeep(option));
    const valueField = this.config.valueField;
    if (this.value) {
      const items =
        typeof this.value === 'string' || typeof this.value === 'number'
          ? [this.value]
          : this.value;
      if (
        items &&
        items instanceof Array &&
        items.find(value => value === option[valueField])
      ) {
        this.selectize.addItem(option[valueField], true);
      }
    }
  }

  onSelectizeOptionRemove(option: any): void {
    this.selectize.removeOption(option[this.config.valueField]);
  }

  evalHasError() {
    const parent = $(this.selectize.$control).parent();
    if (this.formControl) {
      if (this.formControl.touched && this.formControl.invalid) {
        parent.addClass(this.errorClass || 'has-error');
      } else if (parent.hasClass('has-error')) {
        parent.removeClass(this.errorClass || 'has-error');
      }
    }
  }

  /**
   * Update the current placeholder based on the given input parameter.
   */
  updatePlaceholder(): void {
    if (
      this.selectize.items.length === 0 &&
      this.selectize.settings.placeholder !== this.getPlaceholder()
    ) {
      this.selectize.settings.placeholder = this.getPlaceholder();
      this.selectize.updatePlaceholder();
      this.selectize.showInput(); // Without this, when options are cleared placeholder only appears after focus.
    }
  }

  /**
   * Called when a change is detected in the 'enabled' input field.
   * Sets the selectize state based on the new value.
   */
  onEnabledStatusChange(): void {
    this.enabled ? this.selectize.enable() : this.selectize.disable();
  }

  /**
   * Dispatches change event when a value change is detected.
   * @param $event
   */
  onSelectizeValueChange($event: any): void {
    // In some cases this gets called before registerOnChange.
    if (this.onChangeCallback) {
      // Map selectize's value collection back to original ISelectizeItem object
      const data = this.selectize.items.map(v => {
        return this.selectize.options[v];
      });

      this.onChangeCallback(data);
    }
  }

  /**
   * Invoked when the user types while filtering options.
   * @param str
   */
  onSelectizeType(str: string): void {
    if (str.length === 0) {
      this.clearhighlight();
      this.selectize.close();
    }
  }

  onSelectizeItemSelected($event: any): void {
    this.clearhighlight();

    if (this.config.closeAfterSelect) {
      this.selectize.close();
    }
  }

  /**
   * Invoked anytime a key is pressed down on the selectize search field
   * @param e
   */
  onKeydown = e => {
    console.log(e);
    const TABKEY = 9;
    if (e.keyCode === TABKEY) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
    }
  }

  /**
   * Returns the applicable placeholder.
   */
  getPlaceholder(): string {
    if (this.hasOptionsPlaceholder) {
      if (this.options && this.options.length > 0) {
        return this.hasOptionsPlaceholder;
      }
    }
    if (this.noOptionsPlaceholder) {
      if (!this.options || this.options.length === 0) {
        return this.noOptionsPlaceholder;
      }
    }
    return this.placeholder;
  }

  /**
   * Implementation from ControlValueAccessor
   *
   * @param obj
   */
  writeValue(obj: ISelectizeItem[]): void {
    if (obj === this.value) {
      return;
    }

    this.value = obj;

    if (!obj || obj.length === 0) {
      this.selectize.setValue('');
      return;
    }

    const stringValue = obj.map(v => {
      if (!Object.keys(this.selectize.options).some(x => x === v.value)) {
        this.selectize.addOption(v);
      }
      return v.value;
    });

    this.selectize.setValue(stringValue);
  }

  /**
   * Implementation from ControlValueAccessor, callback for (ngModelChange)
   * @param fn
   */
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  /**
   * Implementation from ControlValueAccessor
   * @param fn
   */
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  getOptgroupField(): string {
    return this.config['optgroupField']
      ? this.config['optgroupField']
      : 'optgroup';
  }

  @Input()
  set options(value: any[]) {
    this._options = value;
    if (!this._options_differ && value) {
      this._options_differ = this._differs.find(value).create();
    }
  }

  get options(): any[] {
    return this._options;
  }

  @Input()
  set optgroups(value: any[]) {
    this._optgroups = value;
    if (!this._optgroups_differ && value) {
      this._optgroups_differ = this._differs.find(value).create();
    }
  }

  get optgroups(): any[] {
    return this._optgroups;
  }
}
